import { DimensionContext } from "@/contexts/Dimension"
import Skeleton from "./Skeleton"
import { useContext } from "react"

export default function HomeLoading() {
  const { safeArea } = useContext(DimensionContext)
  return (
    <div className="bg-background top-safe-padding dark:bg-dark-background fixed inset-0 z-[60] flex h-full w-full flex-1 flex-col px-4">
      <Skeleton h={80} style="flex justify-between items-center px-3 my-3">
        <div className="flex items-center gap-x-3">
          <Skeleton round h={48} w={48} inside />
          <Skeleton h={48} w={130} inside />
        </div>
        <Skeleton h={48} w={80} inside />
      </Skeleton>
      <div className="flex items-center justify-center gap-x-3">
        <Skeleton h={44} style="w-[50%] rounded-xl" />
        <Skeleton h={44} style="w-[50%] rounded-xl" />
      </div>
      <Skeleton h={36} w={160} style="my-3" />
      <div className="flex items-center justify-center gap-x-3">
        <Skeleton h={35} style="w-1/3" />
        <Skeleton h={35} style="w-1/3" />
        <Skeleton h={35} style="w-1/3" />
      </div>
      <Skeleton h={140} style="mt-3" />
      <Skeleton
        h={65 + safeArea.bottomSafeArea}
        style="w-full fixed left-0 w-full bottom-0 rounded-tr-2xl rounded-tl-2xl"
      />
    </div>
  )
}
